import * as React from 'react';

import { StageLayout } from '../../components/StageLayout';
import { useFooter } from './utils';
import { RequestFormContainer } from '../RequestFormContainer';

export const MainPageContainer: React.FC = () => {
  const footer = useFooter();

  return (
    <StageLayout footer={footer}>
      <RequestFormContainer />
    </StageLayout>
  );
};

MainPageContainer.displayName = 'MainPageContainer';
